/** Whether the landing was opened specifically to redeem a Stripe gift code. */
export function isGiftCheckoutRequest(search: string): boolean {
  const params = new URLSearchParams(search)
  return params.get("gift") === "1" || Boolean(params.get("discount_code"))
}
